import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/skills/SkillsContent.tsx");
